import { useContext, useEffect, useRef, useState, useMemo } from 'react';
import { DataGrid } from "@mui/x-data-grid";
import { PedidosHistorialDetalleContext } from '../../../../context/pedidoshistorialdetalle/PedidosHistorialDetalleContext';
import { Paginator } from '../../../../components/paginator/Paginator';
import CircularProgress from "@mui/material/CircularProgress";
import useDocumentTitle from "../../../../components/Title";
import ArticulosModal from '../../../articulos/articulosModal/articulosModal';
import { headers } from "./configGrid/headers";
import { formatRows } from "./configGrid//rows";
import { indice } from "../../../../components/DataGrid/indice";

export const DatatableDetalle = ({ pedidoid }) => {
  const titleGrid = "Articulos en el Pedido"
  useDocumentTitle(titleGrid);
  const contexto = useContext(PedidosHistorialDetalleContext);
  const { getPedidosHistorialDetallePanelData } = contexto;

  // Estado para Datos y Paginacion
  const [listaItems, setListaItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  // Estado para Loading
  const [isLoading, setIsLoading] = useState(false);
  // Estados para la paginación
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [numPagina, setNumPagina] = useState(1);
  const [filas, setFilas] = useState(isMobile ? 20 : 100);
  // Estado del buscador
  const [searchOca, setSearchOca] = useState(Number(pedidoid));
  const [searchIdArt, setSearchIdArt] = useState();
  const isFetchingRef = useRef(false);
  // Estado para un modal de observacion
  const [observacionSeleccionada, setObservacionSeleccionada] = useState("");
  const [modalObsOpen, setModalObsOpen] = useState(false);

  useEffect(() => {
    const parsed = Number(pedidoid);
    if (!isNaN(parsed)) {
      setSearchOca(parsed);
    }
  }, [pedidoid]);

  useEffect(() => {
    fetchData();
  }, [searchOca, searchIdArt, numPagina, filas]);

  const fetchData = async () => {
    if (isFetchingRef.current) return; // Evita múltiples llamadas simultáneas
    isFetchingRef.current = true;
    setIsLoading(true);

    try {
      const data = await getPedidosHistorialDetallePanelData(searchOca, searchIdArt, numPagina, filas);
      if (data) {
        setListaItems(data.orderHisDetails || []);
        setTotalItems(data.pagination.totalItems || 0);
      }
    } catch (error) {
      console.error("Error al cargar sliders:", error);
    } finally {
      setIsLoading(false);
      isFetchingRef.current = false;
    }
  };

  const handleSelectArticulo = (artId) => {
    setSearchIdArt(artId); // Guardar el id del artículo seleccionado // Actualizar el formulario con los valores seleccionados
  };

  const handleOpenModalObs = (texto) => {
    setObservacionSeleccionada(texto);
    setModalObsOpen(true);
  };

  const handleCloseModalObs = () => {
    setModalObsOpen(false);
  };

  const datosColum = useMemo(() => {
    return indice(numPagina, filas).concat(
      headers.map((col) => {
        if (col.field === "observacion") {
          return {
            ...col,
            renderCell: (params) => {
              const texto = params.value;
              if (!texto) return null;

              return (
                <button
                  style={{
                    backgroundColor: "#1976d2",
                    color: "#fff",
                    border: "none",
                    padding: "4px 8px",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={() => handleOpenModalObs(texto)}
                >
                  Ver
                </button>
              );
            },
          };
        }
        return col;
      })
    );
  }, [numPagina, filas]);

  const rows = useMemo(() => formatRows(listaItems), [listaItems]);

  return (
    <div className="datatable">
      <div className="datatableTitle">
        <h2>{titleGrid}</h2>
        <div className="filterContainer">
          <div className="searchContainer">
            <div className="inputWrapper">
              {totalItems > 10 &&
                <ArticulosModal
                  handleChange={setSearchIdArt}
                  descSelected={"Seleccione"}
                  onSelect={handleSelectArticulo} />
              }

            </div>
          </div>
          <div className="linkContainer">

          </div>
        </div>
      </div>

      {(isLoading) ? (
        <div className="loading">
          <div style={{ display: "flex", justifyContent: "center", margin: "20px" }}>
            <h1>Cargando datos...</h1>
            <CircularProgress />
          </div>
        </div>
      ) : (
        <>
          <div className="datagridWrapper">
            <DataGrid
              className="datagrid"
              rows={rows}
              rowHeight={28}
              columns={datosColum}
              pageSize={filas}
              paginationMode="server"
              onPageChange={(newPage) => setNumPagina(newPage + 1)} // Convertir de 0-index a 1-index
              onPageSizeChange={(newPageSize) => {
                setFilas(newPageSize);
                setNumPagina(1); // Reinicia a la primera página si cambia el tamaño de la página
              }}
              rowCount={totalItems}
              hideFooterPagination
              autoHeight
              sx={{
                '& .MuiDataGrid-root': {
                  border: 'none',
                },
                '& .MuiDataGrid-cell': {
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                },
              }}
            />
          </div>
          <div className="paginatorWrapper">
            <Paginator
              numPagina={numPagina}
              setNumPagina={setNumPagina}
              totalPages={Math.ceil(totalItems / filas)}
              filas={filas}
              setFilas={setFilas}
              totalDataItems={totalItems}
            />
          </div>
        </>

      )}
      {modalObsOpen && (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            backgroundColor: "#fff",
            padding: "20px",
            borderRadius: "8px",
            boxShadow: "0 2px 10px rgba(0,0,0,0.2)",
            zIndex: 1000,
            width: "300px",
          }}
        >
          {/* Botón cerrar tipo cruz */}
          <button
            onClick={handleCloseModalObs}
            style={{
              position: "absolute",
              top: "8px",
              right: "8px",
              background: "transparent",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
            }}
            aria-label="Cerrar"
          >
            ×
          </button>

          <h3>Observación</h3>
          <p>{observacionSeleccionada}</p>
        </div>
      )}

    </div>
  );
};

export default DatatableDetalle;
